import { useFloatingTree, useListItem } from '@floating-ui/react';
import React, { useContext } from 'react';
import { ItemOption } from "./ItemOption.js";
import { MenuContext } from "../../context/MenuContext.js";
import { SelectContext } from "../../context/SelectContext.js";
import { SettingsContext } from "../../context/SettingsContext.js";
import { isFolderItem } from "../../functions/isFolderItem.js";
import { isNullItem } from "../../functions/isNullItem.js";
import { useMobileCheck } from "../../hooks/useMobileCheck.js";
import { ContextMenuColumn } from "../ContextMenuColumn/ContextMenuColumn.js";
import { InlineFolder } from "../InlineFolder/InlineFolder.js";
import { ItemButton } from "../ItemButton/ItemButton.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function Item({
  item,
  previousFolderLabel,
  level,
  isFiltered,
  index: folderIndex
}) {
  const {
    getItemProps,
    activeIndex
  } = useContext(MenuContext);
  const {
    onSelect
  } = useContext(SelectContext);
  const {
    ref,
    index: itemIndex
  } = useListItem({
    label: item.label ?? ''
  });
  const tree = useFloatingTree();
  const isMobile = useMobileCheck();
  const {
    inlineSearch,
    inlineFolder
  } = useContext(SettingsContext);
  if (isFolderItem(item)) {
    if (inlineFolder) {
      return /*#__PURE__*/_jsx(InlineFolder, {
        label: item.label,
        items: item.elements,
        level: level + 1,
        isFiltered: isFiltered
      });
    }
    return /*#__PURE__*/_jsx(ContextMenuColumn, {
      label: item.label,
      items: item.elements,
      folderItem: item,
      active: activeIndex === folderIndex,
      showSearchInput: (isMobile && inlineSearch) ?? false,
      level: level + 1
    });
  }
  if (isNullItem(item)) {
    return /*#__PURE__*/_jsx(ItemButton, {
      ref: ref,
      "aria-selected": activeIndex === itemIndex,
      ...getItemProps({
        onClick(event) {
          onSelect(undefined);
          tree?.events.emit('click', event);
        }
      }),
      children: item.label
    });
  }
  const selected = activeIndex === itemIndex;
  return /*#__PURE__*/_jsx(ItemOption, {
    item: item,
    previousFolderLabel: previousFolderLabel,
    buttonProps: {
      ref,
      'aria-selected': selected,
      'aria-checked': item.checked,
      ...getItemProps({
        onClick(event) {
          onSelect(item);
          tree?.events.emit('click', event);
        }
      })
    },
    selected: selected
  });
}